/** Persist the Photos tray "Show filename" toggle (survives refresh). Cleared on logout via `clearAuth`. */
export const PHOTOS_TRAY_SHOW_FILENAME_STORAGE_KEY = 'photos-tray-show-filename.v1'

export function readStoredPhotosTrayShowFilename(): boolean {
  if (typeof window === 'undefined') return false

  try {
    const raw = localStorage.getItem(PHOTOS_TRAY_SHOW_FILENAME_STORAGE_KEY)

    if (raw == null || raw === '') return false

    const value = JSON.parse(raw) as unknown

    return value === true
  } catch {
    return false
  }
}

export function writeStoredPhotosTrayShowFilename(enabled: boolean): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(PHOTOS_TRAY_SHOW_FILENAME_STORAGE_KEY, JSON.stringify(enabled))
  } catch {
    // Quota / private mode — ignore.
  }
}

export function clearStoredPhotosTrayShowFilename(): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.removeItem(PHOTOS_TRAY_SHOW_FILENAME_STORAGE_KEY)
  } catch {
    // ignore
  }
}
